import './history.css';

import * as React from 'react';
import { connect } from 'react-redux';
import { Link, Redirect } from 'react-router-dom';
import Group from 'src/entities/Group';
import Member from 'src/entities/Member';
import Wiki from 'src/entities/Wiki';

import Navigation from '../Navigation/global';
import NavigationMember from '../Navigation/member';
import SwitchAdmin from '../Navigation/switchAdmin';

interface IProps {
  groupTitle: string;
  wikiId: string;
  account: Member;
  group: Group;
  wiki: Wiki;
}

interface IState {
  props: 'props';
}

class HistoryComponent extends React.Component<IProps, IState> {
  constructor(props: any) {
    super(props);
    this.state = {
      props: 'props'
    };

    // this.postRequest = this.postRequest.bind(this);
  }

  render() {
    if (this.props.group === undefined || this.props.wiki === undefined) {
      return (
        <Redirect
          to={{
            pathname: '/' + this.props.groupTitle + '/wiki/' + this.props.wikiId
          }}
        />
      );
    }

    return (
      <div id="WikiHistory">
        <Navigation group={this.props.group.title} />

        <div id="NavigationFunction">
          <NavigationMember function="wiki" group={this.props.group} />

          {this.props.account.isSystemAdmin ||
          this.props.group.admins.includes(this.props.account.id) ? (
            <SwitchAdmin group={this.props.group} />
          ) : null}
        </div>

        <div id="Title">{this.props.wiki.title}</div>
        <div id="Histories">
          <div className="History">2019/3/15, 山田</div>
          <div className="History">2019/3/15, 山田</div>
          <div className="History">2019/3/15, 山田</div>
        </div>
        <div id="Actions">
          <Link
            to={'/' + this.props.group.title + '/wiki/' + this.props.wiki.id}
          >
            <span>記事に戻る</span>
          </Link>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state: any, ownProps: any) => ({
  groupTitle: ownProps.match.params.group,
  wikiId: ownProps.match.params.wikiId,
  account: state.Account,
  group: state.Group.find(
    (group: Group) => group.title === ownProps.match.params.group
  ),
  wiki: state.Wiki.find(
    (wiki: Wiki) => wiki.id === Number(ownProps.match.params.wikiId)
  )
});

const mapDispatchToProps = (dispatch: any) => {
  return {
    props: 'props'
  };
};

const History = connect(
  mapStateToProps,
  mapDispatchToProps
)(HistoryComponent);

export default History;



// WEBPACK FOOTER //
// ./src/components/Wiki/history.tsx